import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    algoId: null,
    rawSpec: {
      length: 0,
      width: 0,
      thickness: 0,
      glassClass: '',
      glassColor: '',
      cutType: '',
      margin: 0,
      spacing: 0,
      settingsId: null
    }
  },
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/smartRawMapping/index.js